<template>
    <div>
        <!-- RPGT Result -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>RPGT Result</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="rpgt-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Selling / Disposal Price</b-td>
                                <b-td class="value">RM {{ rpgtData.disposal_price | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Purchase / Acquisition Price</b-td>
                                <b-td class="value">RM {{ rpgtData.acquisition_price | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Permitted Expenses</b-td>
                                <b-td class="value">RM {{ rpgtData.expenses | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Chargeable Gain</b-td>
                                <b-td class="value">RM {{ rpgtData.chargable_gain | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>

                    <hr>

                    <b-table-simple borderless class="rpgt-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Exemption</b-td>
                                <b-td class="value">RM {{ rpgtData.exemption | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Net Chargeable Gain</b-td>
                                <b-td class="value">RM {{ rpgtData.net_chargable_gain | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">{{ rpgtData.rgpt_rate * 100 }}% for {{ rpgtData.year }} Years and Above</b-td>
                                <b-td class="value">RM {{ rpgtData.rgpt_payable | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
export default {
    props: {
        rpgtData: Object,
    }
}
</script>